<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.990234375,6.990000009536743C13.990234375,6.990000009536743,4.410234375,6.990000009536743,4.410234375,6.990000009536743C4.410234375,6.990000009536743,7.700234375,3.700000009536743,7.700234375,3.700000009536743C7.880234375,3.5200000095367434,7.990234375,3.2700000095367434,7.990234375,2.990000009536743C7.990234375,2.4400000095367433,7.540234375,1.9900000095367432,6.990234375,1.9900000095367432C6.710234375,1.9900000095367432,6.460234375,2.100000009536743,6.280234375,2.280000009536743C6.280234375,2.280000009536743,1.280234375,7.280000009536743,1.280234375,7.280000009536743C1.100234375,7.470000009536744,0.990234375,7.720000009536744,0.990234375,7.990000009536743C0.990234375,8.260000009536743,1.100234375,8.520000009536744,1.280234375,8.700000009536744C1.280234375,8.700000009536744,6.280234375,13.700000009536744,6.280234375,13.700000009536744C6.460234375,13.880000009536744,6.710234375,13.990000009536743,6.990234375,13.990000009536743C7.540234375,13.990000009536743,7.990234375,13.540000009536744,7.990234375,12.990000009536743C7.990234375,12.710000009536744,7.880234375,12.460000009536744,7.700234375,12.280000009536742C7.700234375,12.280000009536742,4.410234375,8.990000009536743,4.410234375,8.990000009536743C4.410234375,8.990000009536743,14.000234375,8.990000009536743,14.000234375,8.990000009536743C14.550234375,8.990000009536743,15.000234375,8.540000009536744,15.000234375,7.990000009536743C15.000234375,7.440000009536743,14.540234375,6.990000009536743,13.990234375,6.990000009536743C13.990234375,6.990000009536743,13.990234375,6.990000009536743,13.990234375,6.990000009536743Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowLeft',
} as DefineComponent
</script>
